import { focus, svgColor, svgUri } from '../../helpers'
import { Button, buttonVariant } from '../Button'
import { StyleFn, IconChevrondown, IconChevronup } from '..'

export const IconAdd = {
  data: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="12" cy="12" r="10" stroke="#1C274C" stroke-width="1.5"></circle> <path d="M15 12L12 12M12 12L9 12M12 12L12 9M12 12L12 15" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>',
}

export const IconMinimize = {
  data: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M20.8571 9.75C21.2714 9.75 21.6071 9.41421 21.6071 9C21.6071 8.58579 21.2714 8.25 20.8571 8.25H16.8107L22.5303 2.53033C22.8232 2.23744 22.8232 1.76256 22.5303 1.46967C22.2374 1.17678 21.7626 1.17678 21.4697 1.46967L15.75 7.18934V3.14286C15.75 2.72864 15.4142 2.39286 15 2.39286C14.5858 2.39286 14.25 2.72864 14.25 3.14286V9C14.25 9.41421 14.5858 9.75 15 9.75H20.8571Z" fill="#1C274C"></path> <path d="M3.14286 14.25C2.72864 14.25 2.39286 14.5858 2.39286 15C2.39286 15.4142 2.72864 15.75 3.14286 15.75H7.18934L1.46967 21.4697C1.17678 21.7626 1.17678 22.2374 1.46967 22.5303C1.76256 22.8232 2.23744 22.8232 2.53033 22.5303L8.25 16.8107V20.8571C8.25 21.2714 8.58579 21.6071 9 21.6071C9.41421 21.6071 9.75 21.2714 9.75 20.8571V15C9.75 14.5858 9.41421 14.25 9 14.25H3.14286Z" fill="#1C274C"></path> </g></svg>',
}

export const Collapsible: StyleFn = (theme) => {
  const { color, font, opacity, size } = theme
  const { root: rootButtonStyles } = Button(theme)
  const { focusWithPseudo } = focus(theme)

  const colors = {
    bg: color.type === 'light' ? color.palette.primaryblue['60'] : color.palette.white,
    border: color.type === 'light' ? color.palette.coolgrey[30] : color.palette.coolgrey[60],
    text: color.type === 'light' ? color.palette.coolgrey[90] : color.palette.white,
  }

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      border: `1px solid ${colors.border}`,
      borderRadius: '3px',
      marginBottom: size.spacing[8],
    },
    _expanded: {
      overflowY: 'auto',
      '& > $header > $button:after': {
        backgroundImage: svgUri(svgColor(IconChevronup.data, colors.bg)),
      },
    },
    _autofit: {
      flex: 1,
    },
    _disabled: {
      opacity: opacity.disabled,
      cursor: 'not-allowed',
      '& $button': {
        userSelect: 'none',
        pointerEvents: 'none',
      },
    },
    header: {
      // increase specificity and defeat global
      '&$header': {
        all: 'initial',
        margin: 0,
        padding: 0,
        fontFamily: 'inherit',
        fontWeight: font.weight.bold,
        color: color.brand.normal,
      },
    },
    button: {
      all: 'initial',
      extend: [
        rootButtonStyles,
        buttonVariant(theme, 'ghost'),
        focusWithPseudo({
          pseudo: 'before',
          radius: '3px',
          offset: 1,
        }),
      ],
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      position: 'relative',
      fontSize: font.size.medium,
      '&:after': {
        position: 'absolute',
        content: "''",
        top: size.spacing[8],
        right: size.spacing[16],
        bottom: 0,
        width: size.spacing[20],
        height: size.spacing[20],
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left 0 top 50%',
        backgroundImage: svgUri(svgColor(IconChevrondown.data, colors.bg)),
        transition: 'background-image 0.2s ease-in-out, top 0.2s ease-in-out',
      },
    },
    content: {
      padding: size.spacing[16],
      paddingTop: size.spacing[8],
      color: colors.text,
      overflowY: 'auto',
    },
    _filterpanel: {
      border: 'none',
      marginBottom: 0,
      '& $header': {
        borderBottom: `1px solid ${color.type === 'light' ? color.palette.warmgrey[40] : colors.border}`,
      },
      '& $content': {
        paddingLeft: size.spacing[4],
        paddingRight: size.spacing[4],
      },
      '& $button': {
        paddingLeft: size.spacing[2],
        paddingRight: 0,
        extend: focusWithPseudo({
          pseudo: 'before',
          radius: 0,
          offset: 1,
        }),
      },
      '& $button:after': {
        right: 0,
        top: size.spacing[8],
        backgroundImage: svgUri(
          svgColor(IconAdd.data, color.type === 'light' ? color.palette.primaryblue[60] : color.palette.white),
        ),
      },
      '&$_expanded $button:after': {
        top: size.spacing[4],
        backgroundImage: svgUri(
          svgColor(IconMinimize.data, color.type === 'light' ? color.palette.primaryblue[60] : color.palette.white),
        ),
      },
    },
  }
}
